module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pQCkzp/tc-custom/9781423651222.jpg?1718079009360",
      "alt": "This image is the cover for the book You've Totally Got This!"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("You've Totally Got This!\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("A beautifully designed collection of hand-lettered inspirational quotes for more than a year of Motivational Mondays.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Sometimes all we need is a little nudge: this book serves as inspiration for those facing new beginnings, a sudden change, or just a whole lot to do. "), _c('i', [_vm._v("You’ve Totally Got This!")]), _vm._v(" gives you the encouragement you need with such quotes as:"), _c('br'), _vm._v(" ·       “The secret of getting ahead is getting started.”"), _c('br'), _vm._v(" ·       “Keep some room in your heart for the unimaginable.” (Mary Oliver)"), _c('br'), _vm._v(" ·       “Just say yes and you’ll figure it out afterwards.” (Tina Fey)"), _c('br'), _vm._v(" ·       “You don’t have to see the whole staircase, just take the first step.” (Dr. Martin Luther King, Jr.)"), _c('br'), _vm._v(" ·       “Opportunity is missed by people because it is dressed in overalls and looks like work.”"), _c('br'), _vm._v(" ·       “I have not failed. I’ve just found 10,000 ways that won't work.” (Thomas Edison)"), _c('br'), _vm._v(" ·       “Don't compare your beginning to someone else’s middle.” (Tim Hiller)"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Great for grads, creatives, and entrepreneurs: every spread is like a greeting card, so this delightful volume serves as a stand-alone championing or as the perfect finishing touch to a gift.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Frances Macleod\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Gibbs Smith\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0